//base api url

export const API_URL = "https://api-ihna.e-cert.com.au/public/api";

export const PROFILE_URL = "";